// import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { getSearchParams, getSearchResults, search } from 'b2b-common/services/api/package'
import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByHotDeal,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    packageType: 'package',
    rooms: [{ adults: 2, childAges: [] }],
    countryName: '',
    resortName: ''
  },
  results: [],
  hasTransport: true,

  async init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    const initialRequests = [
      getSearchParams({ packageType: this.params.packageType, dc: this.distribution }),
      getSearchResults({ packageType: this.params.packageType, dc: this.distribution })
      // getHotelAmenities(),
      // getRoomAmenities(),
      // getHotelThemes(),
      // getHotelTypes()
    ]
    const res = await Promise.all(initialRequests)
    this.params = res[0]
    this.results = res[1].results
    this.hasTransport = res[1].has_transport
    this.sort({ sortMethod: this.sortMethod })
    // this.hotelAmenities = res[2]
    // this.roomAmenities = res[3]
    // this.hotelThemes = res[4]
    // this.hotelTypes = res[5]
    this.initDataLoaded = true
    return true
  },

  sort ({ sortMethod = sortByHotDeal }) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ packageType: this.params.packageType, dc: this.distribution })
    this.params = newParams
    this.results = res.results
    this.hasTransport = res.has_transport
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
